import { v4 as uuidv4 } from "uuid";
import BaseViewController from "./base-view-controller";
import { currentLocation } from "../utils/location";
import {
  buildPharmacyViewString,
  searchButtons,
  manualPharmacyFormState
} from "./helpers/pharmacy";
import pharmacyValidation from "./helpers/pharmacy-validation";

class PharmacySearchViewController extends BaseViewController {
  formState = {};

  prepareSubmit(values) {
    return { ...values, ...this.formState };
  }

  handleButtonClick(name, text, action) {
    // Keep using the default handler for the rest of the buttons.
    if (!searchButtons.includes(name)) {
      if (name === "__manualPharmacy") {
        this.formState = { ...manualPharmacyFormState };
      }
      return super.handleButtonClick(name, text, action);
    }
    const searchBy = name.includes(".")
      ? name.split(".")[0]
      : name.replace("MapSearchButton", "");
    switch (searchBy) {
      case "selectedData":
        this.formState = {
          selectedData: { ...text },
          pharmacy_id: text.pharmacy_id,
          pharmacy_view: buildPharmacyViewString(text)
        };
        super.handleButtonClick(name, text, action);
        break;
      case "currentLocation":
      case "zipcode":
      case "city":
      case "citystate":
        this.handlePharmacySearch(searchBy);
        break;
      default:
        super.handleButtonClick(name, text, action);
        break;
    }
  }

  handlePharmacySearch = searchBy => {
    this.appData.searchPharmacies(
      searchBy === "currentLocation" ? currentLocation() : null
    );
  };

  preprocessScreenData() {
    const { values } = this.appData;

    (this.screen.conditionals || []).forEach(c => {
      const field = (c.fields || []).find(x => x.name === "state");
      if (field) {
        field.text = values.state;
      }
    });

    const selectedCondition =
      values.searchBy &&
      this.screen.conditionals?.find(c => c.value === values.searchBy);
    const isManualPharmacyMissing = !selectedCondition?.fields?.find(c =>
      c.name.includes("manualPharmacy")
    );

    if (values.searchBy === "Recent Pharmacies") {
      const pharmacyList = this.screen.data.pharmacies.map(p => {
        const addressData = p.address
          ? {
              name: p.pharmacy_nm,
              address_line1: p.address.address_line1,
              city: p.address.city,
              state: p.address.state_province,
              zipCode: p.address.postal
            }
          : {
              name: p.pharmacy_nm,
              address_line1: "",
              city: "",
              state: "",
              zipCode: ""
            };
        const data = {
          name: "selectedData",
          // eslint-disable-next-line new-cap
          childrenData: {
            componentName: "Address",
            ...addressData
          },
          key: "selectedData",
          fieldKey: `selectedData_${uuidv4()}`,
          type: "listItemWrapper",
          title: p.pharmacy_nm,
          // TODO: Temporary fix till other screens are built
          action: this.screen.action,
          selectedData: {
            StoreName: p.pharmacy_nm,
            twenty_four_hour_flg: p.twenty_four_hour_flg,
            ncpdp_id: p.ncpdp_id,
            pharmacy_id: p.pharmacy_id,
            member_pharmacy_relation_id: p.member_pharmacy_relation_id,
            isBranded: p.isBranded
          },
          childrenType: "pharmacy-address"
        };

        if (p.address) {
          data.selectedData["Address|AddressLine1"] = p.address.address_line1;
          data.selectedData["Address|City"] = p.address.city;
          data.selectedData["Address|State"] = p.address.state_province;
          data.selectedData["Address|ZipCode"] = p.address.postal;
          data.selectedData.party_address_id = p.address.party_address_id;
        }

        if (p.work_fax) {
          data.selectedData.PrimaryFax =
            (p.work_fax.area_сode || "") + (p.work_fax.phone_number || "");
        }

        if (p.work_phone) {
          data.selectedData.party_phone_fax_id =
            p.work_phone.party_phone_fax_id;
          data.selectedData.PrimaryPhone =
            (p.work_phone.area_сode || "") + (p.work_phone.phone_number || "");
        }

        return data;
      });
      this.screen = {
        ...this.screen,
        fields: [...this.screen.fields, ...pharmacyList]
      };
    } else if (isManualPharmacyMissing) {
      this.screen = {
        ...this.screen,
        fields: [
          ...this.screen.fields,
          {
            type: "bar",
            params: "TDFieldOptionAutoCorrectNone"
          },
          {
            name: "__manualPharmacy",
            type: "text",
            params: "TDFieldOptionBold|TDFieldOptionAutoCorrectNone",
            title: this.appData.settings.translations.add_pharmacy_manually,
            action: {
              type: "screen",
              value: {
                PharmacySearch: "PharmacyAddManually",
                PharmacyAddSearch: "PharmacyNewManual"
              }[this.screen.name]
            }
          }
        ]
      };
    }
  }
}

PharmacySearchViewController.fieldValidation = pharmacyValidation;

export default PharmacySearchViewController;
